module.exports = __webpack_public_path__ + "assets/img/4d8edd9c3d709a8a939073afe2060643.png";